import React from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

const SortableHeader = ({ 
    label, 
    field, 
    currentSort, 
    currentOrder, 
    onSort, 
    className = "" 
}) => {
    const isActive = currentSort === field;
    
    return (
        <th 
            className={`px-3 py-3 cursor-pointer hover:bg-gray-100 transition-colors group ${className}`}
            onClick={() => onSort(field)}
        >
            <div className="flex items-center gap-1">
                <span className={`text-xs uppercase font-bold tracking-wider ${isActive ? 'text-blue-600' : 'text-gray-500'}`}>
                    {label}
                </span>
                <div className={`transition-opacity duration-200 ${isActive ? 'opacity-100' : 'opacity-20 group-hover:opacity-100'}`}>
                    {isActive ? (
                        currentOrder === 'ASC' 
                            ? <ArrowUp className="w-3 h-3 text-blue-600" /> 
                            : <ArrowDown className="w-3 h-3 text-blue-600" />
                    ) : (
                        <ArrowUpDown className="w-3 h-3 text-gray-400" />
                    )}
                </div>
            </div>
        </th>
    );
};

export default SortableHeader;
